const ListIcons = ({ type, size = 24, color }) => {
  const icons = {
    rename: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2.66602 13.3332H5.33268L12.3327 6.33321C12.5078 6.15811 12.6467 5.95024 12.7414 5.72147C12.8362 5.4927 12.885 5.2475 12.885 4.99988C12.885 4.75225 12.8362 4.50705 12.7414 4.27828C12.6467 4.04951 12.5078 3.84164 12.3327 3.66654C12.1576 3.49145 11.9497 3.35255 11.7209 3.25779C11.4922 3.16303 11.247 3.11426 10.9993 3.11426C10.7517 3.11426 10.5065 3.16303 10.2778 3.25779C10.049 3.35255 9.84111 3.49145 9.66602 3.66654L2.66602 10.6665V13.3332Z"
          stroke="url(#paint0_linear_2011_174613)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 4.33301L11.6667 6.99967"
          stroke="url(#paint1_linear_2011_174613)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.666 12.667H14.666"
          stroke="url(#paint2_linear_2011_174613)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2011_174613"
            x1="2.00466"
            y1="11.6425"
            x2="13.9132"
            y2="11.8618"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2011_174613"
            x1="8.82742"
            y1="6.55848"
            x2="11.935"
            y2="6.61572"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2011_174613"
            x1="10.4071"
            y1="13.5015"
            x2="15.0449"
            y2="13.8433"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
        </defs>
      </svg>
    ),
    move: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12 6L14 8L12 10"
          stroke="url(#paint0_linear_2011_174619)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 8H14"
          stroke="url(#paint1_linear_2011_174619)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 6L2 8L4 10"
          stroke="url(#paint2_linear_2011_174619)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 8H6"
          stroke="url(#paint3_linear_2011_174619)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 12L8 14L10 12"
          stroke="url(#paint4_linear_2011_174619)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 10V14"
          stroke="url(#paint5_linear_2011_174619)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 4L8 2L6 4"
          stroke="url(#paint6_linear_2011_174619)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 2V6"
          stroke="url(#paint7_linear_2011_174619)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2011_174619"
            x1="11.8706"
            y1="9.3382"
            x2="14.2018"
            y2="9.35967"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2011_174619"
            x1="9.74113"
            y1="8.83455"
            x2="14.3789"
            y2="9.17627"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2011_174619"
            x1="1.87056"
            y1="9.3382"
            x2="4.20183"
            y2="9.35967"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2011_174619"
            x1="1.74113"
            y1="8.83455"
            x2="6.37887"
            y2="9.17627"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2011_174619"
            x1="5.74113"
            y1="13.6691"
            x2="10.3977"
            y2="13.8407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_2011_174619"
            x1="7.93528"
            y1="13.3382"
            x2="9.10099"
            y2="13.3436"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_2011_174619"
            x1="5.74113"
            y1="3.6691"
            x2="10.3977"
            y2="3.84065"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_2011_174619"
            x1="7.93528"
            y1="5.3382"
            x2="9.10099"
            y2="5.34357"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
        </defs>
      </svg>
    ),
    copy: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_2011_174630)">
          <path
            d="M4.66602 6.44499C4.66602 5.97344 4.85334 5.5212 5.18678 5.18776C5.52022 4.85432 5.97246 4.66699 6.44402 4.66699H12.2213C12.4548 4.66699 12.686 4.71298 12.9018 4.80233C13.1175 4.89169 13.3135 5.02265 13.4786 5.18776C13.6437 5.35286 13.7747 5.54886 13.864 5.76458C13.9534 5.9803 13.9993 6.2115 13.9993 6.44499V12.2223C13.9993 12.4558 13.9534 12.687 13.864 12.9027C13.7747 13.1185 13.6437 13.3145 13.4786 13.4796C13.3135 13.6447 13.1175 13.7756 12.9018 13.865C12.686 13.9543 12.4548 14.0003 12.2213 14.0003H6.44402C6.21053 14.0003 5.97932 13.9543 5.7636 13.865C5.54789 13.7756 5.35188 13.6447 5.18678 13.4796C5.02168 13.3145 4.89071 13.1185 4.80136 12.9027C4.71201 12.687 4.66602 12.4558 4.66602 12.2223V6.44499Z"
            stroke="url(#paint0_linear_2011_174630)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.67467 11.158C2.47023 11.0415 2.30018 10.873 2.18172 10.6697C2.06325 10.4663 2.00057 10.2353 2 10V3.33333C2 2.6 2.6 2 3.33333 2H10C10.5 2 10.772 2.25667 11 2.66667"
            stroke="url(#paint1_linear_2011_174630)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2011_174630"
            x1="4.06198"
            y1="12.4561"
            x2="14.9384"
            y2="12.6565"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2011_174630"
            x1="1.41754"
            y1="9.64281"
            x2="11.9057"
            y2="9.83268"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <clipPath id="clip0_2011_174630">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    favourite: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M9.33398 2V4.66667C9.33398 4.84348 9.40422 5.01305 9.52925 5.13807C9.65427 5.2631 9.82384 5.33333 10.0007 5.33333H12.6673M9.33398 2H4.66732C4.3137 2 3.97456 2.14048 3.72451 2.39052C3.47446 2.64057 3.33398 2.97971 3.33398 3.33333V12.6667C3.33398 13.0203 3.47446 13.3594 3.72451 13.6095C3.97456 13.8595 4.3137 14 4.66732 14H11.334C11.6876 14 12.0267 13.8595 12.2768 13.6095C12.5268 13.3594 12.6673 13.0203 12.6673 12.6667V5.33333M9.33398 2L12.6673 5.33333M7.86731 11.2113L6.41931 11.97C6.37634 11.9924 6.328 12.0024 6.27969 11.9988C6.23137 11.9953 6.18499 11.9784 6.14571 11.9501C6.10643 11.9217 6.0758 11.883 6.05725 11.8383C6.0387 11.7935 6.03295 11.7445 6.04065 11.6967L6.31731 10.0893L5.14598 8.95134C5.11102 8.91754 5.08626 8.87459 5.07454 8.8274C5.06282 8.7802 5.0646 8.73066 5.07969 8.68444C5.09477 8.63821 5.12255 8.59715 5.15985 8.56595C5.19716 8.53476 5.24248 8.51468 5.29065 8.508L6.90931 8.27334L7.63331 6.81134C7.65497 6.76779 7.68834 6.73115 7.72968 6.70554C7.77102 6.67993 7.81868 6.66636 7.86731 6.66636C7.91594 6.66636 7.96361 6.67993 8.00495 6.70554C8.04629 6.73115 8.07966 6.76779 8.10131 6.81134L8.82531 8.27334L10.444 8.508C10.492 8.51491 10.5371 8.53512 10.5743 8.56635C10.6114 8.59758 10.6391 8.63857 10.6541 8.6847C10.6692 8.73083 10.671 8.78025 10.6595 8.82737C10.6479 8.87449 10.6234 8.91743 10.5886 8.95134L9.41731 10.0893L9.69331 11.696C9.7016 11.7439 9.69628 11.7932 9.67797 11.8382C9.65965 11.8833 9.62908 11.9223 9.58971 11.9508C9.55034 11.9793 9.50376 11.9963 9.45526 11.9997C9.40675 12.0031 9.35827 11.9928 9.31531 11.97L7.86731 11.2113Z"
          stroke="url(#paint0_linear_2011_174637)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2011_174637"
            x1="2.72995"
            y1="12.0146"
            x2="13.6079"
            y2="12.1705"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
        </defs>
      </svg>
    ),
    download: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_2011_174641)">
          <path
            d="M2.66602 11.333V12.6663C2.66602 13.02 2.80649 13.3591 3.05654 13.6092C3.30659 13.8592 3.64573 13.9997 3.99935 13.9997H11.9993C12.353 13.9997 12.6921 13.8592 12.9422 13.6092C13.1922 13.3591 13.3327 13.02 13.3327 12.6663V11.333"
            stroke="url(#paint0_linear_2011_174641)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.66602 7.33301L7.99935 10.6663L11.3327 7.33301"
            stroke="url(#paint1_linear_2011_174641)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 2.66699V10.667"
            stroke="url(#paint2_linear_2011_174641)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2011_174641"
            x1="1.97569"
            y1="13.5585"
            x2="14.343"
            y2="14.4697"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2011_174641"
            x1="4.23456"
            y1="10.1148"
            x2="11.9956"
            y2="10.4008"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2011_174641"
            x1="7.93528"
            y1="9.3434"
            x2="9.10101"
            y2="9.34608"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <clipPath id="clip0_2011_174641">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    share: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_2011_174648)">
          <path
            d="M2 8C2 8.53043 2.21071 9.03914 2.58579 9.41421C2.96086 9.78929 3.46957 10 4 10C4.53043 10 5.03914 9.78929 5.41421 9.41421C5.78929 9.03914 6 8.53043 6 8C6 7.46957 5.78929 6.96086 5.41421 6.58579C5.03914 6.21071 4.53043 6 4 6C3.46957 6 2.96086 6.21071 2.58579 6.58579C2.21071 6.96086 2 7.46957 2 8Z"
            stroke="url(#paint0_linear_2011_174648)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 4C10 4.53043 10.2107 5.03914 10.5858 5.41421C10.9609 5.78929 11.4696 6 12 6C12.5304 6 13.0391 5.78929 13.4142 5.41421C13.7893 5.03914 14 4.53043 14 4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4Z"
            stroke="url(#paint1_linear_2011_174648)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12Z"
            stroke="url(#paint2_linear_2011_174648)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.80078 7.13288L10.2008 4.86621"
            stroke="url(#paint3_linear_2011_174648)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.80078 8.86621L10.2008 11.1329"
            stroke="url(#paint4_linear_2011_174648)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2011_174648"
            x1="1.74113"
            y1="9.3382"
            x2="6.40247"
            y2="9.42407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2011_174648"
            x1="9.74113"
            y1="5.3382"
            x2="14.4025"
            y2="5.42407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2011_174648"
            x1="9.74113"
            y1="13.3382"
            x2="14.4025"
            y2="13.4241"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2011_174648"
            x1="5.51602"
            y1="6.75786"
            x2="10.6387"
            y2="6.94103"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2011_174648"
            x1="5.51602"
            y1="10.7579"
            x2="10.6387"
            y2="10.941"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <clipPath id="clip0_2011_174648">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    information: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_2011_174658)">
          <path
            d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
            stroke="url(#paint0_linear_2011_174658)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 6H8.00667"
            stroke="url(#paint1_linear_2011_174658)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.33398 8H8.00065V10.6667H8.66732"
            stroke="url(#paint2_linear_2011_174658)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2011_174658"
            x1="1.22338"
            y1="12.0146"
            x2="15.2074"
            y2="12.2722"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2011_174658"
            x1="7.99957"
            y1="6.83455"
            x2="8.00734"
            y2="6.83455"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2011_174658"
            x1="7.24769"
            y1="10.2255"
            x2="8.80187"
            y2="10.2398"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <clipPath id="clip0_2011_174658">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    trash: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_2011_174668)">
          <path
            d="M2.66602 4.66699H13.3327"
            stroke="url(#paint0_linear_2011_174668)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.66602 7.33301V11.333"
            stroke="url(#paint1_linear_2011_174668)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.33398 7.33301V11.333"
            stroke="url(#paint2_linear_2011_174668)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33398 4.66699L4.00065 12.667C4.00065 13.0206 4.14113 13.3598 4.39118 13.6098C4.64122 13.8598 4.98036 14.0003 5.33398 14.0003H10.6673C11.0209 14.0003 11.3601 13.8598 11.6101 13.6098C11.8602 13.3598 12.0007 13.0206 12.0007 12.667L12.6673 4.66699"
            stroke="url(#paint3_linear_2011_174668)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 4.66667V2.66667C6 2.48986 6.07024 2.32029 6.19526 2.19526C6.32029 2.07024 6.48986 2 6.66667 2H9.33333C9.51014 2 9.67971 2.07024 9.80474 2.19526C9.92976 2.32029 10 2.48986 10 2.66667V4.66667"
            stroke="url(#paint4_linear_2011_174668)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2011_174668"
            x1="1.97569"
            y1="5.50154"
            x2="13.9479"
            y2="7.85391"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2011_174668"
            x1="6.6013"
            y1="10.6712"
            x2="7.767"
            y2="10.6766"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2011_174668"
            x1="9.26927"
            y1="10.6712"
            x2="10.435"
            y2="10.6766"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2011_174668"
            x1="2.72995"
            y1="12.4561"
            x2="13.6064"
            y2="12.6565"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2011_174668"
            x1="5.74113"
            y1="4.22547"
            x2="10.4005"
            y2="4.35421"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <clipPath id="clip0_2011_174668">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    details: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_1617_84857)">
          <path
            d="M6 4H13.3333"
            stroke="url(#paint0_linear_1617_84857)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 8H13.3333"
            stroke="url(#paint1_linear_1617_84857)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 12H13.3333"
            stroke="url(#paint2_linear_1617_84857)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33398 4V4.00667"
            stroke="url(#paint3_linear_1617_84857)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33398 8V8.00667"
            stroke="url(#paint4_linear_1617_84857)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33398 12V12.0067"
            stroke="url(#paint5_linear_1617_84857)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1617_84857"
            x1="5.5254"
            y1="4.83455"
            x2="13.9209"
            y2="5.96864"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1617_84857"
            x1="5.5254"
            y1="8.83455"
            x2="13.9209"
            y2="9.96864"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1617_84857"
            x1="5.5254"
            y1="12.8346"
            x2="13.9209"
            y2="13.9686"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1617_84857"
            x1="3.26927"
            y1="4.00556"
            x2="3.40428"
            y2="4.37861"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_1617_84857"
            x1="3.26927"
            y1="8.00556"
            x2="3.40428"
            y2="8.37861"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_1617_84857"
            x1="3.26927"
            y1="12.0056"
            x2="3.40428"
            y2="12.3786"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <clipPath id="clip0_1617_84857">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    activity: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2 8.00033H4.66667L6.66667 13.3337L9.33333 2.66699L11.3333 8.00033H14"
          stroke="url(#paint0_linear_1617_84867)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1617_84867"
            x1="1.22338"
            y1="11.5689"
            x2="15.2061"
            y2="11.8586"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
        </defs>
      </svg>
    ),
    restore: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8 5.33301V7.99967L9.33333 9.33301"
          stroke="url(#paint0_linear_1617_86199)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.0332 8.54943C2.1826 10.0161 2.86671 11.3764 3.95503 12.3708C5.04334 13.3652 6.45967 13.9242 7.93379 13.941C9.40791 13.9579 10.8366 13.4314 11.9474 12.4621C13.0581 11.4928 13.7731 10.1484 13.956 8.68561C14.1388 7.22278 13.7767 5.74383 12.9388 4.53092C12.1008 3.31802 10.8456 2.45607 9.41272 2.10953C7.97981 1.76299 6.46948 1.95611 5.16987 2.65205C3.87026 3.348 2.87235 4.49804 2.36654 5.88277M2.0332 2.54943V5.88277H5.36654"
          stroke="url(#paint1_linear_1617_86199)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1617_86199"
            x1="7.91371"
            y1="8.67121"
            x2="9.46796"
            y2="8.68075"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1617_86199"
            x1="1.25858"
            y1="3.92679"
            x2="15.2066"
            y2="3.67052"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
        </defs>
      </svg>
    ),
    deleteForEver: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2.66602 4.66699H13.3327"
          stroke="url(#paint0_linear_1617_86204)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33398 4.66699L4.00065 12.667C4.00065 13.0206 4.14113 13.3598 4.39118 13.6098C4.64122 13.8598 4.98036 14.0003 5.33398 14.0003H10.6673C11.0209 14.0003 11.3601 13.8598 11.6101 13.6098C11.8602 13.3598 12.0007 13.0206 12.0007 12.667L12.6673 4.66699"
          stroke="url(#paint1_linear_1617_86204)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 4.66667V2.66667C6 2.48986 6.07024 2.32029 6.19526 2.19526C6.32029 2.07024 6.48986 2 6.66667 2H9.33333C9.51014 2 9.67971 2.07024 9.80474 2.19526C9.92976 2.32029 10 2.48986 10 2.66667V4.66667"
          stroke="url(#paint2_linear_1617_86204)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66602 8L9.33268 10.6667M9.33268 8L6.66602 10.6667"
          stroke="url(#paint3_linear_1617_86204)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1617_86204"
            x1="1.97569"
            y1="5.50154"
            x2="13.9479"
            y2="7.85391"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1617_86204"
            x1="2.72995"
            y1="12.4561"
            x2="13.6064"
            y2="12.6565"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1617_86204"
            x1="5.74113"
            y1="4.22547"
            x2="10.4005"
            y2="4.35421"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1617_86204"
            x1="6.49343"
            y1="10.2255"
            x2="9.60099"
            y2="10.2827"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
        </defs>
      </svg>
    ),
    deleteDark: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="65"
        viewBox="0 0 64 65"
        fill="none"
      >
        <path
          d="M32 62.7041C48.5685 62.7041 62 49.2726 62 32.7041C62 16.1356 48.5685 2.7041 32 2.7041C15.4315 2.7041 2 16.1356 2 32.7041C2 49.2726 15.4315 62.7041 32 62.7041Z"
          fill="#46191A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.9984 30.7565C27.19 30.7565 27.3738 30.8326 27.5093 30.9682C27.6449 31.1037 27.721 31.2875 27.721 31.4791V40.6545C27.721 40.8462 27.6449 41.03 27.5093 41.1655C27.3738 41.301 27.19 41.3771 26.9984 41.3771C26.8068 41.3771 26.623 41.301 26.4875 41.1655C26.3519 41.03 26.2758 40.8462 26.2758 40.6545V31.4791C26.2758 31.2875 26.3519 31.1037 26.4875 30.9682C26.623 30.8326 26.8068 30.7565 26.9984 30.7565ZM30.7989 31.4791C30.7989 31.2875 30.875 31.1037 31.0106 30.9682C31.1461 30.8326 31.3299 30.7565 31.5215 30.7565C31.7131 30.7565 31.8969 30.8326 32.0324 30.9682C32.168 31.1037 32.2441 31.2875 32.2441 31.4791V40.6545C32.2441 40.8462 32.168 41.03 32.0324 41.1655C31.8969 41.301 31.7131 41.3771 31.5215 41.3771C31.3299 41.3771 31.1461 41.301 31.0106 41.1655C30.875 41.03 30.7989 40.8462 30.7989 40.6545V31.4791ZM35.322 31.4791C35.322 31.2875 35.3981 31.1037 35.5337 30.9682C35.6692 30.8326 35.853 30.7565 36.0446 30.7565C36.2362 30.7565 36.42 30.8326 36.5555 30.9682C36.691 31.1037 36.7672 31.2875 36.7672 31.4791V40.6545C36.7672 40.8462 36.691 41.03 36.5555 41.1655C36.42 41.301 36.2362 41.3771 36.0446 41.3771C35.853 41.3771 35.6692 41.301 35.5337 41.1655C35.3981 41.03 35.322 40.8462 35.322 40.6545V31.4791ZM21.5699 27.0313L22.6896 45.3956C22.7109 45.7499 22.8667 46.0827 23.1252 46.326C23.3837 46.5692 23.7254 46.7045 24.0803 46.7041H38.9626C39.3175 46.7045 39.6592 46.5692 39.9177 46.326C40.1762 46.0827 40.3321 45.7499 40.3533 45.3956L41.473 27.0313H21.5699ZM21.3934 21.4146H27.2643V20.2754C27.2643 19.4099 27.9702 18.7041 28.8356 18.7041H34.2074C35.0728 18.7041 35.7787 19.4099 35.7787 20.2754V21.4146H41.6495C42.417 21.4146 43.0428 22.0405 43.0428 22.8079V25.1346C43.0428 25.3834 42.8399 25.5863 42.5912 25.5863H20.4516C20.3319 25.586 20.2172 25.5384 20.1325 25.4537C20.0479 25.3691 20.0002 25.2543 20 25.1346V22.8079C20 22.0404 20.626 21.4146 21.3934 21.4146Z"
          fill="#BE2828"
        />
      </svg>
    ),
    delete: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="65"
        viewBox="0 0 64 65"
        fill="none"
      >
        <path
          d="M32 62.7041C48.5685 62.7041 62 49.2726 62 32.7041C62 16.1356 48.5685 2.7041 32 2.7041C15.4315 2.7041 2 16.1356 2 32.7041C2 49.2726 15.4315 62.7041 32 62.7041Z"
          fill="#FFE6E6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.9984 30.7565C27.19 30.7565 27.3738 30.8326 27.5093 30.9682C27.6449 31.1037 27.721 31.2875 27.721 31.4791V40.6545C27.721 40.8462 27.6449 41.03 27.5093 41.1655C27.3738 41.301 27.19 41.3771 26.9984 41.3771C26.8068 41.3771 26.623 41.301 26.4875 41.1655C26.3519 41.03 26.2758 40.8462 26.2758 40.6545V31.4791C26.2758 31.2875 26.3519 31.1037 26.4875 30.9682C26.623 30.8326 26.8068 30.7565 26.9984 30.7565ZM30.7989 31.4791C30.7989 31.2875 30.875 31.1037 31.0106 30.9682C31.1461 30.8326 31.3299 30.7565 31.5215 30.7565C31.7131 30.7565 31.8969 30.8326 32.0324 30.9682C32.168 31.1037 32.2441 31.2875 32.2441 31.4791V40.6545C32.2441 40.8462 32.168 41.03 32.0324 41.1655C31.8969 41.301 31.7131 41.3771 31.5215 41.3771C31.3299 41.3771 31.1461 41.301 31.0106 41.1655C30.875 41.03 30.7989 40.8462 30.7989 40.6545V31.4791ZM35.322 31.4791C35.322 31.2875 35.3981 31.1037 35.5337 30.9682C35.6692 30.8326 35.853 30.7565 36.0446 30.7565C36.2362 30.7565 36.42 30.8326 36.5555 30.9682C36.691 31.1037 36.7672 31.2875 36.7672 31.4791V40.6545C36.7672 40.8462 36.691 41.03 36.5555 41.1655C36.42 41.301 36.2362 41.3771 36.0446 41.3771C35.853 41.3771 35.6692 41.301 35.5337 41.1655C35.3981 41.03 35.322 40.8462 35.322 40.6545V31.4791ZM21.5699 27.0313L22.6896 45.3956C22.7109 45.7499 22.8667 46.0827 23.1252 46.326C23.3837 46.5692 23.7254 46.7045 24.0803 46.7041H38.9626C39.3175 46.7045 39.6592 46.5692 39.9177 46.326C40.1762 46.0827 40.3321 45.7499 40.3533 45.3956L41.473 27.0313H21.5699ZM21.3934 21.4146H27.2643V20.2754C27.2643 19.4099 27.9702 18.7041 28.8356 18.7041H34.2074C35.0728 18.7041 35.7787 19.4099 35.7787 20.2754V21.4146H41.6495C42.417 21.4146 43.0428 22.0405 43.0428 22.8079V25.1346C43.0428 25.3834 42.8399 25.5863 42.5912 25.5863H20.4516C20.3319 25.586 20.2172 25.5384 20.1325 25.4537C20.0479 25.3691 20.0002 25.2543 20 25.1346V22.8079C20 22.0404 20.626 21.4146 21.3934 21.4146Z"
          fill="#DC1818"
        />
      </svg>
    ),
    Spaces: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3.33398 3.33301V10.6663H10.6673"
          stroke="url(#paint0_linear_2011_174678)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33398 3.33301H10.6673"
          stroke="url(#paint1_linear_2011_174678)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6673 3.33301L13.3333 5.99967"
          stroke="url(#paint2_linear_2011_174678)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3333 3.33301H10.6673V5.99967"
          stroke="url(#paint2_linear_2011_174678)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2011_174678"
            x1="3.07465"
            y1="7.5585"
            x2="11.2703"
            y2="7.5585"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2011_174678"
            x1="3.07465"
            y1="3.83301"
            x2="11.2703"
            y2="3.83301"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2011_174678"
            x1="10.4071"
            y1="4.22547"
            x2="13.592"
            y2="4.22547"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C3DE7" />
            <stop offset="1" stopColor="#67308F" />
          </linearGradient>
        </defs>
      </svg>
    )
  };

  return icons[type];
};

export default ListIcons;
